export default __webpack_public_path__ + "static/3-1-0-0-f6624840d08bcc6b7b2416d13b7132b8.jpg";